import { render } from "./DoubleSlider.vue?vue&type=template&id=55e24a9e&scoped=true"
import script from "./DoubleSlider.vue?vue&type=script&lang=js"
export * from "./DoubleSlider.vue?vue&type=script&lang=js"

import "./DoubleSlider.vue?vue&type=style&index=0&id=55e24a9e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55e24a9e"

export default script